import { render, staticRenderFns } from "./SalutationSelect.vue?vue&type=template&id=29eb44e0&"
import script from "./SalutationSelect.vue?vue&type=script&lang=js&"
export * from "./SalutationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../plentyDevTool/38547/54/d2gPmPluginReturnsEGP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/patrickbittner/plentyDevTool/38547/54/d2gPmPluginReturnsEGP/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29eb44e0')) {
      api.createRecord('29eb44e0', component.options)
    } else {
      api.reload('29eb44e0', component.options)
    }
    module.hot.accept("./SalutationSelect.vue?vue&type=template&id=29eb44e0&", function () {
      api.rerender('29eb44e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plentymarkets/5.0.31/plugin-ceres/resources/js/src/app/components/customer/SalutationSelect.vue"
export default component.exports